const getOffset = function (_element, _object = false) {
    var rect = _element.getBoundingClientRect();
    var win = _element.ownerDocument.defaultView;

    return _object
        ? {
              x: rect.left + win.pageXOffset,
              y: rect.top + win.pageYOffset,
          }
        : rect.top + win.pageYOffset;
};

export default getOffset;
